<script setup lang="ts">
import logoSvg from '~/assets/images/events-logo.svg?raw';

withDefaults(defineProps<{ height?: number }>(), { height: 28 });
</script>

<template>
  <!-- eslint-disable vue/no-v-html -->
  <span class="app-logo" :style="{ height: `${height}px` }" v-html="logoSvg" />
</template>

<style scoped>
.app-logo {
  display: inline-flex;
  align-items: center;
}

.app-logo :deep(svg) {
  height: 100%;
  width: auto;
}
</style>
